import { TooltipTrigger } from "@visiblethread/react-components";
import { arrayOf, bool, shape, string } from "prop-types";

import classes from "./CommentBody.module.scss";

const EMAIL_TOOLTIP_DELAY_MS = 1500;

const escapeForRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const renderMention = (mention, key) => (
  <TooltipTrigger key={key} content={mention.userName} delay={EMAIL_TOOLTIP_DELAY_MS}>
    <span className={mention.active ? classes["mention"] : undefined}>
      @{mention.displayName}
    </span>
  </TooltipTrigger>
);

const CommentBody = ({ body, mentions = [], editedAt }) => {
  if (!body) {
    return null;
  }

  const activeTokenMentions = mentions.filter((mention) =>
    body.includes(mention.token)
  );

  const editedIndicator = editedAt && (
    <span className={classes["edited"]}> (edited)</span>
  );

  if (activeTokenMentions.length === 0) {
    return (
      <div className={classes["body"]}>
        {body}
        {editedIndicator}
      </div>
    );
  }

  const splitPattern = activeTokenMentions
    .map((mention) => mention.token)
    .sort((a, b) => b.length - a.length)
    .map(escapeForRegExp)
    .join("|");

  const parts = body.split(new RegExp(`(${splitPattern})`, "g"));

  return (
    <div className={classes["body"]}>
      {parts.map((part, index) => {
        const mention = activeTokenMentions.find((m) => m.token === part);
        return mention ? renderMention(mention, index) : part;
      })}
      {editedIndicator}
    </div>
  );
};

CommentBody.propTypes = {
  body: string,
  mentions: arrayOf(
    shape({
      token: string.isRequired,
      userName: string,
      displayName: string,
      active: bool,
    })
  ),
  editedAt: string,
};

export default CommentBody;
